/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

export type GetShareableInvoicePdfLocale = typeof GetShareableInvoicePdfLocale[keyof typeof GetShareableInvoicePdfLocale];


export const GetShareableInvoicePdfLocale = {
  'en-US': 'en-US',
  'de-DE': 'de-DE',
  'it-IT': 'it-IT',
  'fr-FR': 'fr-FR',
  'es-ES': 'es-ES',
  'sl-SI': 'sl-SI',
  'pt-PT': 'pt-PT',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'hr-HR': 'hr-HR',
  'sv-SE': 'sv-SE',
  'fi-FI': 'fi-FI',
  'et-EE': 'et-EE',
  'bg-BG': 'bg-BG',
  'cs-CZ': 'cs-CZ',
  'sk-SK': 'sk-SK',
  'nb-NO': 'nb-NO',
  'is-IS': 'is-IS',
} as const;
